// API Utility Functions
import { getApiEndpoints } from '../config/api';
import { isProductionDomain } from '../config/environment';

/**
 * Get API endpoints with domain-specific handling
 * Forces relative URLs for production domain to avoid mixed content issues
 */
export const getApiEndpointsForDomain = () => {
  const isProdDomain = isProductionDomain();
  
  if (isProdDomain) {
    // Return relative URLs for production domain
    return {
      LOGIN: '/api/auth/login',
      REGISTER: '/api/auth/register',
      FORGOT_PASSWORD: '/api/auth/forgot-password',
      VERIFY_RESET_TOKEN: '/api/auth/verify-reset-token',
      RESET_PASSWORD: '/api/auth/reset-password',
      CREATE_ADMIN: '/api/auth/create-admin',
      ME: '/api/auth/me',
      
      CREATE_NEW_REGISTRATION: '/api/create-new-registration',
      REGISTRATION: '/api/registration',
      REGISTRATION_BY_ID: (id: number) => `/api/registration/${id}`,
      
      BUSINESS_ACTIVITIES: '/api/business-activities',
      COMPANY_TYPE: '/api/company-type',
      BUSINESS_ACTIVITY: '/api/business-activity',
      
      COMPANY_NAME: '/api/company-name',
      
      OWNERS_INFO: '/api/owners-info',
      UPLOAD_DOCUMENT: '/api/upload-document',
      
      CHARTER: '/api/charter',
      
      ADDITIONAL_SERVICES: '/api/additional-services',
      
      SUBMIT: '/api/submit',
      
      MY_REGISTRATIONS: '/api/my-registrations',
      MY_REGISTRATION_BY_ID: (id: number) => `/api/my-registrations/${id}`,
      MARK_PAYMENT_COMPLETE: (id: number) => `/api/my-registrations/${id}/mark-payment-complete`,
      
      ADMIN_DASHBOARD: '/api/admin/dashboard',
      ADMIN_REGISTRATIONS: '/api/admin/registrations',
      ADMIN_REGISTRATION_BY_ID: (id: number) => `/api/admin/registrations/${id}`,
      UPDATE_REGISTRATION_STATUS: (id: number) => `/api/admin/registrations/${id}/status`,
      UPDATE_PAYMENT_LINK: (id: number) => `/api/admin/registrations/${id}/payment-link`,
      DELETE_REGISTRATION: (id: number) => `/api/admin/registrations/${id}`,
      
      RESOLVE_FILE: (filename: string) => `/api/resolve-file/${encodeURIComponent(filename)}`,
      DOWNLOAD_FILE: (filename: string) => `/api/download-file/${encodeURIComponent(filename)}`,
      ADMIN_DOWNLOAD_FILE: (filename: string) => `/api/admin/download-file/${encodeURIComponent(filename)}`,
    };
  }
  
  // For other domains, use the original dynamic configuration
  return getApiEndpoints();
};